<template>
	<div id="app">
		<transition name="van-fade" mode="out-in">
			<router-view />
		</transition>
	</div>
</template>

<script>
	export default {
		mounted () {
			// 微信鉴权
			// this.$wx.setConfigParams().then(_this => _this.config())
		}
	}
</script>
